import { render, staticRenderFns } from "./chooseTable.vue?vue&type=template&id=4972e926&"
import script from "./chooseTable.vue?vue&type=script&lang=js&"
export * from "./chooseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports